import { css } from '@microsoft/fast-element';
import { genericFormStyling } from '../../../../styles/common/form.styles';

export const VppaFormStyles = css`
  ${genericFormStyling}
  zero-text-area,
  zero-text-field,
  zero-number-field,
  zero-select {
    width: 100%;
  }

  .auto-exec-message {
    font-size: 12px;
    color: var(--error);
    font-family: Roboto-Regular, Roboto, sans-serif;
  }

  .auto-exec-message-div {
    padding-top: 20px;
  }
`;
